module.exports = __webpack_public_path__ + "static/media/picto-circles-black.5c92c3b1.svg";